import InboxDropdownMenu from './InboxDropdownMenu';

export default InboxDropdownMenu;
